<div class="footnote-container">
  <div class="accordion-parent-header">
    <p>INSTRUCTIONS</p>
    <h3 *ngIf="this.reportFormDataItem">
      {{this.reportFormDataItem.fieldTitle}}
      <!--      <a>-->
      <!--        <i class="fa-solid fa-multiply"></i>-->
      <!--      </a>-->
    </h3>
  </div>
  <!--*ngIf="this.formWarnings && this.formWarnings.length"-->
  <mat-accordion *ngIf="this.formWarnings && this.formWarnings.length" class="custom-accordion box-appearance">
    <div class="headers flex flex-row justify-between items-center" (click)="toggleHelpRequestList()">
      <strong>Warnings</strong>
      <i class="fa-solid fa-plus" *ngIf="!isHelpRequestListVisible"></i>
      <i class="fa-solid fa-minus" *ngIf="isHelpRequestListVisible"></i>
    </div>
    <div class="content-container" *ngIf="isHelpRequestListVisible">
      <!--<p>{{this.reportFormDataItem.instruction}}</p>-->
      <div *ngIf="mandatoryWarnings && mandatoryWarnings.length" class="legend-header mandatory">

        <span></span>Mandatory Warning <span>({{mandatoryWarnings.length}})</span>
        <div>
          <particle-dynamic-tooltip-container style="display: inline-block;" [openOption]="'click'" [theme]="'dark'"
                                              [htmlElement]="mandatoryWarningsText">
            <i class="fa-regular fa-circle-info"></i></particle-dynamic-tooltip-container>
        </div>
      </div>
      <div *ngIf="advisoryWarnings && advisoryWarnings.length" class="legend-header advisory">

        <span></span>Advisory Warning ({{ advisoryWarnings.length }})
        <div>
          <particle-dynamic-tooltip-container style="display: inline-block" [openOption]="'click'" [theme]="'dark'"
                                              [htmlElement]="advisoryWarningsText">
            <i class="fa-regular fa-circle-info"></i></particle-dynamic-tooltip-container>
        </div>
      </div>
      <div *ngIf="analyticalWarnings && analyticalWarnings.length" class="legend-header analytical">

        <span></span>Analytical Warning ({{analyticalWarnings.length}})
        <div>
          <particle-dynamic-tooltip-container style="display: inline-block;" [openOption]="'click'" [theme]="'dark'"
                                              [htmlElement]="analyticalWarningsText">
            <i class="fa-regular fa-circle-info"></i></particle-dynamic-tooltip-container>
        </div>
      </div>
    </div>
  </mat-accordion>
  <mat-accordion class="custom-accordion box-appearance">
    <div *ngIf="this.reportFormDataItem" class="headers flex flex-row justify-between items-center"
         (click)="toggleReleaseNotes()">
      <strong>Field Data</strong>
      <i class="fa-solid fa-plus" *ngIf="!isReleaseNotesVisible"></i>
      <i class="fa-solid fa-minus" *ngIf="isReleaseNotesVisible"></i>
    </div>
    <div class="content-container" *ngIf="isReleaseNotesVisible">
      <dl>
        <dt><h4>Form Value: </h4></dt>
        <dd>
          <p><strong>{{this.reportFormDataItem?.userValue}}</strong></p>
        </dd>
        <dt><h4>Data Source Value: </h4></dt>
        <dd><p>{{this.reportFormDataItem?.calculatedValue}}</p></dd>
      </dl>


    </div>
  </mat-accordion>
  <mat-accordion *ngIf="this.reportFormDataItem && this.reportFormDataItem.instruction"
                 class="custom-accordion box-appearance">
    <div class="headers flex flex-row justify-between items-center" (click)="toggleInstructionVisible()">
      <strong>Instructions</strong>
      <i class="fa-solid fa-plus" *ngIf="!isInstructionsVisible"></i>
      <i class="fa-solid fa-minus" *ngIf="isInstructionsVisible"></i>
    </div>
    <div class="content-container" *ngIf="isInstructionsVisible">
      <!--<p>{{this.reportFormDataItem.instruction}}</p>-->
      <particle-dynamic-html-anchor [content]="this.reportFormDataItem.instruction"></particle-dynamic-html-anchor>
    </div>
  </mat-accordion>


  <mat-accordion *ngIf="this.cbcForms && this.cbcForms.length"
                 class="custom-accordion box-appearance">
    <div class="headers flex flex-row justify-between items-center" (click)="toggleIsCbcFormsListVisible()">
      <strong>CbC Forms</strong>
      <i class="fa-solid fa-plus" *ngIf="!isCbcFormsListVisible"></i>
      <i class="fa-solid fa-minus" *ngIf="isCbcFormsListVisible"></i>
    </div>
    <div class="content-container" *ngIf="isCbcFormsListVisible">
      <!--<p>{{this.reportFormDataItem.instruction}}</p>-->
      <ul>
        <li *ngFor="let cbcForm of cbcForms">
          <a (click)="downloadCbcForm(cbcForm.forms.form)">{{ cbcForm.forms.form.name }}</a>
          ({{cbcForm.forms.language.name}})
        </li>
      </ul>
    </div>
  </mat-accordion>

</div>
